// extracted by mini-css-extract-plugin
export default {"tabContainer":"tab_tabContainer__6rq2i"};